import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { SignatureDocument } from '../../../../model';
import { GenericNormalizedModel } from '../../../../model/generic-normalized-model';
import { RootState } from '../../../root-store';
import { SignatureAreaState } from './signature-area-types';
import { DIY_ONBOARDING_CODE } from '../../../../model/signature-area/signature-document-type-lists';

export const selectSignatureAreaState = (state: RootState) =>
  state.features.signatureArea;
export const getDocuments: any = createDraftSafeSelector(
  selectSignatureAreaState,
  (state: SignatureAreaState) => state.documents
);
export const getAllDocuments: any = createDraftSafeSelector(
  getDocuments,
  (documents: GenericNormalizedModel<SignatureDocument>) =>
    documents.all.map((id) => documents.items[id])
);
export const getSelectedSection: any = createDraftSafeSelector(
  selectSignatureAreaState,
  (state: SignatureAreaState) => state.selectedSection
);
export const getDocumentsListBySection: any = createDraftSafeSelector(
  getAllDocuments,
  getSelectedSection,
  (documents: SignatureDocument[], selectedSection) => {
    const validDocuments = documents.filter(
      (document) => document.isExpired === false
    );
    switch (selectedSection) {
      case 'ALL': {
        return validDocuments;
      }
      case 'TO_SIGN': {
        const toSign = validDocuments.filter((doc) => {
          return (
            doc.type?.practiceType === DIY_ONBOARDING_CODE ||
            (doc.isMySignatureRequired && !doc.isExpiringForMe)
          );
        });
        return toSign;
      }
      case 'EXPIRING': {
        return validDocuments.filter(
          (doc) => doc.isMySignatureRequired && doc.isExpiringForMe
        );
      }
      default: {
        return validDocuments;
      }
    }
  }
);
export const getSelectedDocument: any = createDraftSafeSelector(
  getDocuments,
  (documents: GenericNormalizedModel<SignatureDocument>) =>
    documents.items[documents.selected]
);

const getSelectedModuleId = createDraftSafeSelector(
  selectSignatureAreaState,
  (state: SignatureAreaState) => state.selectedModuleId
);

export const getSelectedModule: any = createDraftSafeSelector(
  getSelectedDocument,
  getSelectedModuleId,
  (document: SignatureDocument, idModule: string) =>
    document?.modules?.find((item) => item.id === idModule)
);
